import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import McqCorrect from './mcqCorrect';
import McqIncorrect from './mcqIncorrect';
import { appendScript } from '../../../../utils/appendScript';
import FeedbackLayout from '../../utils/feedback/feedbackLayout';

const McqFeedback = ({ rightFeedbackProps: { score } }) => {
	useEffect(() => {
		appendScript('testMCQ');
	}, []);

	return (
		<section className="quiz-area-options quiz-more-answer ">
			{score === 1 ? (
				<McqCorrect marking="correct-answer" />
			) : score === 0 ? (
				<McqIncorrect />
			) : (
				<McqCorrect marking="no-grade" />
			)}
			<input type="hidden" name="choosen-answer" className="choosen-answer" />
		</section>
	);
};

const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	};
};

export default compose(
	FeedbackLayout,
	connect(mapStateToProps, null),
)(McqFeedback);
